const initialState = {
  testsList: [],
};

export const testsReducer = (state = initialState, action) => {
  if (typeof action.execute === "function" && action.type === "tests")
    return action.execute(state);
  return state;
};
